///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    const checkbox = document.querySelector('.js-unavailable-for-review-checkbox');

    if (checkbox) {
      const checkboxInput = new CheckboxInput();

      checkbox.addEventListener('change', function(e) {
        checkboxInput.toggleFields(e);
      });

      // manually trigger change event on checkbox when
      // rendering template after failed room review save
      if (checkboxInput.reasonSelectField.value == 'Other') {
        // Create a new 'change' event
        const changeEvent = new CustomEvent('change');

        // Check checkbox and dispatch event
        checkbox.checked = true;
        checkbox.dispatchEvent(changeEvent);
      }
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function CheckboxInput() {
    this.reasonFormFields   = document.querySelectorAll('.js-unavailable-for-review-fields');

    this.reasonSelectField  = document.querySelector('.js-unavailable-for-review-reason');

    this.reasonCommentField = document.querySelector('.js-comment-field');

    this.submitButton       = document.querySelector('.js-room-review-submit');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggles elements involved in
  //               capturing data on classrooms
  //               that are unavailable for review
  //
  CheckboxInput.prototype.toggleFields = function(e) {
    if (e.target.checked) {
      this.reasonFormFields.forEach((item, i) => {
        if (item.classList.contains('js-required')) {
          item.querySelectorAll('input, select').forEach((field, i) => {
            field.required = 'required';
          });
        }

        item.classList.remove('d-none');
      });

      confirmUnavailableButton(this.submitButton);
    } else if (!e.target.checked) {
      this.reasonFormFields.forEach((item, i) => {
        item.querySelectorAll('input, select').forEach((field, i) => {
          field.required = null;
        });

        item.classList.add('d-none');
      });

      // clear field values when checkbox is deselected
      this.reasonCommentField.value = '';
      this.reasonSelectField.selectedIndex = 0;

      startRoomReviewButton(this.submitButton);
    }
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Updates form submit button from start
  //               new review to confirm unavailable
  //
  function confirmUnavailableButton(submitButton) {
    if (submitButton.classList.contains('btn-success')) {
      submitButton.classList.remove('btn-success');
      submitButton.classList.add('btn-warning');

      submitButton.value = 'Confirm Room is Unavailable for Review';
    }
  }

  ///////////////////////////////////////////////
  //
  // Description - Updates form submit button from confirm
  //               unavailable to start new review
  //
  function startRoomReviewButton(submitButton) {
    if (submitButton.classList.contains('btn-warning')) {
      submitButton.classList.remove('btn-warning');
      submitButton.classList.add('btn-success');

      submitButton.value = 'Start Room Review';
    }
  }
}());
